export const MY_BLOCKED_USERS_Q = /* GraphQL */ `
  query MyBlockedUsers {
    myBlockedUsers {
      id
      name
      headline
      pictureUrl
      blockedAt
    }
  }
`;

export const BLOCK_USER_M = /* GraphQL */ `
  mutation BlockUser($humanId: ID!) {
    blockUser(humanId: $humanId)
  }
`;

export const UNBLOCK_USER_M = /* GraphQL */ `
  mutation UnblockUser($humanId: ID!) {
    unblockUser(humanId: $humanId)
  }
`;

export const REPORT_CONTENT_M = /* GraphQL */ `
  mutation ReportContent($targetType: String!, $targetId: ID!, $reason: String) {
    reportContent(targetType: $targetType, targetId: $targetId, reason: $reason)
  }
`;
